import React, { useState, useEffect } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  FileTextOutlined,
  UserOutlined,
  LogoutOutlined,
  CoffeeOutlined,
  CalendarOutlined,
  SettingOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Layout, Menu, Popover } from "antd";
import md5 from "crypto-js/md5";

// Style
import "./style.css";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { routes_array } from "../../Routes";
import { useDispatch, useSelector } from "react-redux";
import { setLogin, setUser } from "../../Redux/Slice/userSlice";
import { setLoader } from "../../Redux/Slice/loaderSlice";

const { Header, Sider, Content } = Layout;

const Layoutpage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.data);
  const hash = md5(userData.email).toString();
  const gravatarUrl = `https://www.gravatar.com/avatar/${hash}?s=200&d=identicon`;
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState("1");

  useEffect(() => {
    const path = location.pathname.substr(1);
    setCurrent(path || "1");
  }, [location]);

  const handleClick = (e) => {
    setCurrent(e.key ?? "1");
  };

  const handlePopOverClick = (e) => {
    if (e.key === "5") {
      dispatch(setLogin(false));
      dispatch(setUser({}));
      navigate("/login");
      window.localStorage.removeItem("ts_invoices");
    }
    // else if (e.key === "4") {
    //   navigate("/settings");
    // } else if (e.key === "3") {
    //   navigate("/official-holidays");
    // } else if (e.key === "2") {
    //   navigate("/vacation");
    // } else if (e.key === "1") {
    //   navigate("/");
    // }
  };

  const content = (
    <div>
      <Menu
        theme="light"
        style={{ borderInlineEnd: "none" }}
        onClick={handlePopOverClick}
      >
        {/* <Menu.Item key="1">
          <span>Invoices</span>
        </Menu.Item>
        <Menu.Item key="2">
          <span>Vacation</span>
        </Menu.Item>
        <Menu.Item key="3">
          <span>Official Holidays</span>
        </Menu.Item>
        <Menu.Item key="4">
          <span>Settings</span>
        </Menu.Item> */}
        <Menu.Item key="5">
          <span>Logout</span>
        </Menu.Item>
      </Menu>
    </div>
  );

  const renderMenu = () => {
    return [
      {
        key: "1",
        label: (
          <Link to="/">
            <DashboardOutlined />
            <span>Dashboard</span>
          </Link>
        ),
      },
      {
        key: "2",
        label: (
          <Link to="/invoices">
            <FileTextOutlined />
            <span>Invoices</span>
          </Link>
        ),
      },
      {
        key: "3",
        label: (
          <Link to="/vacation">
            <CoffeeOutlined />
            <span>Vacation</span>
          </Link>
        ),
      },
      {
        key: "4",
        label: (
          <Link to="/official-holidays">
            <CalendarOutlined />
            <span>Official Holidays</span>
          </Link>
        ),
      },
      // {
      //   key: "4",
      //   label: (
      //     <Link to="/settings">
      //       <SettingOutlined />
      //       <span>Settings</span>
      //     </Link>
      //   ),
      // },
      // {
      //   key: "logout",
      //   label: (
      //     <span
      //       onClick={() => {
      //         dispatch(setLogin(false));
      //         dispatch(setUser({}));
      //         navigate("/login");
      //         window.localStorage.removeItem("ts_invoices");
      //       }}
      //     >
      //       <LogoutOutlined />
      //       <span>Logout</span>
      //     </span>
      //   ),
      // },
    ];
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "30px 0px",
          }}
        >
          <img
            src={
              !collapsed
                ? require("../../Images/logo.png")
                : require("../../Images/icon.png")
            }
            alt="logo"
            height={!collapsed ? 20 : 40}
          />
        </div>
        <Menu
          theme="light"
          defaultSelectedKeys={["1"]}
          onClick={handleClick}
          mode="inline"
          items={renderMenu()}
          selectedKeys={[
            location.pathname === "/vacation"
              ? "3"
              : location.pathname === "/official-holidays"
              ? "4"
              : location.pathname === "/invoices"
              ? "2"
              : "1",
          ]}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            {userData.role === "2" && (
              <Button
                onClick={() => navigate("/admin")}
                style={{ marginRight: 10 }}
                type="dashed"
              >
                Admin
              </Button>
            )}
            <Popover
              style={{ padding: 0 }}
              placement="bottomLeft"
              content={content}
              title=""
            >
              <Avatar
                src={gravatarUrl}
                style={{
                  backgroundColor: "#1677ff",
                  verticalAlign: "middle",
                  marginRight: 15,
                }}
                size="default"
                gap={2}
                icon={<UserOutlined />}
              ></Avatar>
            </Popover>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 24px",
            padding: 24,
            minHeight: 280,
            background: "#ffffff",
            borderRadius: 10,
          }}
        >
          <Routes>
            {routes_array.map((route) => {
              return <Route path={route.path} element={route.element} />;
            })}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};
export default Layoutpage;
